import { Trans } from '@lingui/react';
import { Typography } from '@startuptools/ui/Typography';
import { Stack } from '@startuptools/ui/Stack';
import { Alert } from '@startuptools/ui/Alert';
import { Box } from '@startuptools/ui/Box';
import { Button } from '@startuptools/ui/Button';
import { ParticipantsTable } from '../ParticipantsTable';
import { siShowDocumentsLink } from '../../../../components/Links';
import { GqlShareIssue, GqlShareIssueParticipant } from '../../../../graphql/base-types.graphql';
import { DisplayIdentity } from '@startuptools/business-ui/identity/Identity';
import { useNavigate } from '../../../../components/Navigate';
import { Link } from 'react-router-dom';

export const SiStepPaymentStatus = ({
  shareIssue,
  sips,
  sirId,
}: {
  shareIssue: Pick<
    GqlShareIssue,
    'id' | 'pricePerShare' | 'currency' | 'companyId' | 'shareClasses' | 'paymentKindCash'
  >;
  sips: (Pick<GqlShareIssueParticipant, 'id' | 'paymentStatus' | 'numberOfShares' | 'shareClass' | 'paymentKind'> & {
    identity: DisplayIdentity;
    proxy?: DisplayIdentity | null;
  })[];
  sirId: string;
}) => {
  const { link } = useNavigate();

  return (
    <Stack gap={3}>
      <Typography level="h4">
        <Trans id="Participants' payment status" />
      </Typography>

      <Alert>
        <Trans id="In order to generate the registration form, you must fill in the payment status for all participants." />
      </Alert>

      <ParticipantsTable shareIssue={shareIssue} sips={sips} paymentKind={null} sirId={sirId} />

      <Box>
        <Button component={Link} to={link(siShowDocumentsLink({ id: shareIssue.id }))}>
          <Trans id="Continue to Overview" />
        </Button>
      </Box>
    </Stack>
  );
};
